import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations, APIEndpoints } from "@/store/enums/StoreEnums";
import {
  Module,
  Action,
  Mutation,
  VuexModule,
  config,
} from "vuex-module-decorators";

config.rawError = true;

@Module
export default class JobModule extends VuexModule {
  @Action
  [Actions.GET_JOBS]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get("/attorney/" + APIEndpoints.JOBS)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/attorney/${APIEndpoints.JOBS}/${payload.jobId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB_NOTIFICATIONS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.NOTIFICATIONS}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB_PAYMENTS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.PAYMENTS}/${APIEndpoints.JOB}/${payload.jobId}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB_TIMELINE](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.TIMELINE}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB_FORM](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.FORM}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.MARK_JOB_NOTIFICATION_AS_READ](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.NOTIFICATIONS}/${APIEndpoints.READ}`,
        payload.notificationsIds
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.REQUEST_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}/${APIEndpoints.REQUEST}`,
        payload
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.GET_JOB_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}/${payload.documentId}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_JOB_DOCUMENTS](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.ADD_NEW_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.UPDATE_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}/${payload.documentId}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.DELETE_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.delete(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}/${payload.documentId}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.SUBMIT_DOCUMENT](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.DOCS}/${payload.documentId}/${APIEndpoints.SUBMIT}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_JOB_REVIEW](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.REVIEW}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.ADD_JOB_REVIEW](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(`/attorney/${APIEndpoints.REVIEWS}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_JOB_REVIEW](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put(
        `/attorney/${APIEndpoints.REVIEWS}/${payload.reviewId}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.CANCEL_JOB](payload) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.STATUS}/${APIEndpoints.CANCEL}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
